import { BaseService } from "./BaseService";

export const FonteService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('fonte/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos fontes:', error);
            return false;
        }
    },
    async select() {
        try {
            return await BaseService.fetchResponseFromAPIGet('fonte/select');
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos fontes:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('fonte', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de ação:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`fonte/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de ação:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`fonte/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de ação:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('fonte/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir ação(s):', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('fonte/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar ação(s):', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('fonte/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar ação(s):', error);
            return false;
        }
    }, 
}